/* zen nomad Harmony launch sections. Runs once, re-binds on Theme Editor section reloads. */
(function(){
  if (window.__znh) return; window.__znh = true;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var SHORT = {"extra small":"XS","x-small":"XS","xs":"XS","small":"S","s":"S","medium":"M","m":"M","large":"L","l":"L","extra large":"XL","x-large":"XL","xl":"XL","extra loveable":"XL"};
  function short(label){ var k = String(label).toLowerCase().trim(); return SHORT[k] || label; }
  function money(c){ var d = c/100; return "$" + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }

  var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("is-in"); io.unobserve(e.target); } });
  }, {rootMargin:"0px 0px -8% 0px", threshold:0.08}) : null;

  function initReveals(root){
    root.querySelectorAll(".reveal").forEach(function(el){ if (io) io.observe(el); else el.classList.add("is-in"); });
  }

  function initBuybox(box){
    if (box.__znh) return; box.__znh = true;
    var dataEl = box.querySelector("script[data-znh-versions]");
    if (!dataEl) return;
    var V; try { V = JSON.parse(dataEl.textContent); } catch(e){ return; }
    if (!V.length) return;
    var code = box.getAttribute("data-code") || "";
    var low = parseInt(box.getAttribute("data-low") || "2", 10);
    var q = function(sel){ return box.querySelector(sel); };
    var gallery = q(".choose__gallery"), sizesEl = q("[data-sizes]"), stock = q("[data-stock]"), add = q("[data-add]");
    var cur = 0, sel = null;
    function updateAdd(){
      var v = V[cur];
      if (sel === null){ add.textContent = add.getAttribute("data-label-select"); add.setAttribute("aria-disabled","true"); stock.textContent = ""; return; }
      var vr = v.variants[sel];
      add.removeAttribute("aria-disabled");
      add.textContent = add.getAttribute("data-label-add") + ", " + money(vr.price) + " " + (box.getAttribute("data-cur")||"CAD");
      if (vr.managed && vr.qty > 0 && vr.qty <= low){
        stock.textContent = vr.qty === 1 ? "Last one in " + short(vr.label) + ", small batch" : "Only " + vr.qty + " left in " + short(vr.label);
      } else { stock.textContent = ""; }
    }
    function renderSizes(){
      sizesEl.innerHTML = "";
      V[cur].variants.forEach(function(vr, i){
        var b = document.createElement("button");
        b.type = "button"; b.className = "size"; b.textContent = short(vr.label);
        b.setAttribute("aria-label", vr.label + (vr.available ? "" : ", sold out"));
        if (!vr.available) b.disabled = true;
        b.addEventListener("click", function(){
          sel = i; sizesEl.querySelectorAll(".size").forEach(function(x){ x.classList.remove("is-on"); x.setAttribute("aria-pressed","false"); });
          b.classList.add("is-on"); b.setAttribute("aria-pressed","true"); updateAdd();
        });
        sizesEl.appendChild(b);
      });
    }
    function setVersion(i, instant){
      cur = i; sel = null; var v = V[i];
      ["eyebrow","title","fabric","colour"].forEach(function(k){ var el = q("[data-bb-" + k + "]"); if (el) el.textContent = v[k] || ""; });
      q("[data-bb-price]").textContent = money(v.price);
      renderSizes(); updateAdd();
      var swap = function(){
        gallery.querySelectorAll("img").forEach(function(el, n){ var im = v.imgs[n]; if (!im) return; el.src = im.src; el.removeAttribute("srcset"); el.alt = im.alt || ""; });
        gallery.classList.remove("is-swapping");
      };
      if (instant || reduce){ swap(); return; }
      gallery.classList.add("is-swapping"); setTimeout(swap, 380);
    }
    box.querySelectorAll(".tab").forEach(function(t, i){
      t.addEventListener("click", function(){
        box.querySelectorAll(".tab").forEach(function(x){ x.classList.remove("is-active"); x.setAttribute("aria-selected","false"); });
        t.classList.add("is-active"); t.setAttribute("aria-selected","true"); setVersion(i);
      });
    });
    add.addEventListener("click", function(ev){
      ev.preventDefault();
      if (sel === null) return;
      var vr = V[cur].variants[sel];
      add.setAttribute("aria-disabled","true"); add.textContent = "Adding...";
      fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, body: JSON.stringify({items:[{id: vr.id, quantity: 1}]})})
        .then(function(r){ if (!r.ok) throw r; return r.json(); })
        .then(function(){ window.location.href = code ? "/discount/" + encodeURIComponent(code) + "?redirect=/cart" : "/cart"; })
        .catch(function(){ add.removeAttribute("aria-disabled"); add.textContent = "Could not add, please try again"; });
    });
    V.forEach(function(v){ v.imgs.forEach(function(im){ var i = new Image(); i.src = im.src; }); });
    setVersion(0, true);
  }

  var ticking = false;
  function onScroll(){
    ticking = false;
    var vh = window.innerHeight;
    document.querySelectorAll(".znh.js-reveal .reveal:not(.is-in)").forEach(function(el){ if (el.getBoundingClientRect().top < vh * 0.94) el.classList.add("is-in"); });
    if (!reduce) document.querySelectorAll("[data-drift]").forEach(function(strip){
      var r = strip.parentElement.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
      var max = Math.max(0, strip.scrollWidth - window.innerWidth + 40);
      strip.style.transform = "translate3d(" + (-p * max) + "px,0,0)";
    });
    var dock = document.querySelector(".znh [data-dock]");
    if (dock){
      var hero = document.querySelector(".znh .hero"), choose = document.querySelector(".znh .choose");
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > vh;
      var inChoose = false;
      if (choose){ var cb = choose.getBoundingClientRect(); inChoose = cb.top < vh && cb.bottom > 0; }
      var show = past && !inChoose;
      dock.classList.toggle("is-on", show); dock.setAttribute("aria-hidden", show ? "false" : "true");
      document.body.classList.add("znh-has-dock");
    }
  }

  function headerOffset(){
    var first = document.querySelector(".znh-section"); if (!first || window.scrollY > 5) return;
    var b = 0;
    document.querySelectorAll(".header-section .header, .mobile-header, .header-section .mobile-header").forEach(function(h){
      var cs = getComputedStyle(h);
      if (h.offsetHeight && cs.position === "absolute") b = Math.max(b, h.getBoundingClientRect().bottom + window.scrollY);
    });
    var r = first.getBoundingClientRect().top + window.scrollY;
    first.style.paddingTop = b > r ? (b - r) + "px" : "";
  }
  function init(root){
    headerOffset();
    document.body.classList.add("znh-page");
    document.querySelectorAll(".znh").forEach(function(el){ el.classList.add("js-reveal"); });
    initReveals(root || document);
    (root || document).querySelectorAll("[data-znh-buybox]").forEach(initBuybox);
    onScroll();
  }
  window.addEventListener("scroll", function(){ if (!ticking){ ticking = true; requestAnimationFrame(onScroll); } }, {passive:true});
  window.addEventListener("resize", function(){ onScroll(); headerOffset(); });
  window.addEventListener("load", headerOffset);
  setTimeout(headerOffset, 600); setTimeout(headerOffset, 2000);
  if ("ResizeObserver" in window) document.querySelectorAll(".header-section .header, .mobile-header").forEach(function(h){ new ResizeObserver(headerOffset).observe(h); });
  document.addEventListener("shopify:section:load", function(e){ init(e.target); e.target.querySelectorAll(".reveal").forEach(function(el){ el.classList.add("is-in"); }); });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function(){ init(); }); else init();
})();
